import { Skeleton } from "@/components/ui/skeleton";

export const CompetitorsSkeleton = () => {
  return (
    <main className="flex-1 p-3 md:p-6 pb-16 flex justify-center overflow-y-auto">
      <div className="w-full max-w-[1200px] space-y-4 md:space-y-6 pb-16" role="status" aria-label="Ładowanie konkurencji">
        {/* Next scraping progress */}
        <Skeleton className="h-12 w-full rounded-xl" />

        {/* Time range selector */}
        <div className="flex justify-start">
          <div className="inline-flex gap-1 rounded-xl border border-border/50 p-1">
            <Skeleton className="h-8 w-28 rounded-lg" />
            <Skeleton className="h-8 w-28 rounded-lg" />
          </div>
        </div>

        {/* Tabs */}
        <div className="flex gap-1 rounded-xl border border-border/50 p-1">
          <Skeleton className="h-9 flex-1 rounded-lg" />
          <Skeleton className="h-9 flex-1 rounded-lg" />
          <Skeleton className="h-9 flex-1 rounded-lg" />
        </div>

        {/* Growth chart placeholder */}
        <div className="rounded-2xl border border-border/50 p-6 space-y-4">
          <Skeleton className="h-5 w-44" />
          <Skeleton className="h-[250px] w-full rounded-lg" />
        </div>
      </div>
    </main>
  );
};
